import { Injectable } from '@angular/core';
import {
  DcTypes,
  Feature,
  FeatureNames,
  FeatureProperties,
  TypedFeatureProperties,
} from '../../../../projects/client';
import { FeatureValueStrategy } from './feature-value-strategy.model';

@Injectable({ providedIn: 'root' })
export class DeviceCascadeMemberIdStrategy implements FeatureValueStrategy {
  supports(
    feature: Feature<TypedFeatureProperties<number>, unknown>,
    propertyName: string
  ): boolean {
    const property = feature?.properties?.[propertyName];

    return property?.type === DcTypes.number && feature?.feature === FeatureNames.cascadeMemberId;
  }

  transformValue(
    feature: Feature<FeatureProperties, unknown>,
    propertyName: string,
    _digitsInfo?: string
  ): string {
    return feature?.properties?.[propertyName]?.value?.toString();
  }
}
